import clsx from 'clsx';

type Props = {
  checked?: boolean;
  label: string;
};

export default function OptionButton({ checked, label }: Props) {
  return (
    <div
      className={clsx([
        'transition-standard cursor-pointer',
        checked ? 'btn-sm border-orange border' : 'btn-sm-reverse border-orange border',
      ])}
    >
      {label}
    </div>
  );
}
